import { SidebarNavLink, NavbarBrand, Heading, Navbar } from 'legion-ui';
import * as React from 'react';
export default {
  SidebarNavLink,
  NavbarBrand,
  Heading,
  Navbar,
  React
};